import { IBrand } from 'app/shared/model/brand.model';

export interface IProduct {
  id?: string;
  name?: string | null;
  brand?: IBrand | null;
}

export const defaultValue: Readonly<IProduct> = {};
